import React from 'react';
import { useApp } from '../../context/AppContext.tsx';
import {
  Users,
  Award,
  ShieldCheck,
  HeartHandshake,
  Zap,
  TrendingUp,
  Headphones,
  Star,
  CheckCircle2,
} from 'lucide-react';

const iconMap: Record<string, any> = {
  Users,
  Award,
  ShieldCheck,
  HeartHandshake,
  Zap,
  Sparkles: Star,
  TrendingUp,
  Headphones,
  Star,
  CheckCircle2,
};

export default function QuickStats() {
  const { settings } = useApp();
  const primaryColor = settings?.theme.primaryColor || '#059669';

  const defaultItems = [
    {
      id: 'qs-1',
      icon: 'Users',
      value: '500+',
      label: 'Klien Korporasi & Instansi',
      desc: 'Dipercaya berbagai BUMN & swasta',
    },
    {
      id: 'qs-2',
      icon: 'Award',
      value: '99.8%',
      label: 'Tingkat Kepuasan Peserta',
      desc: 'Rating bintang 5 dari ratusan ulasan',
    },
    {
      id: 'qs-3',
      icon: 'ShieldCheck',
      value: '100%',
      label: 'Standar Keamanan Bersertifikat',
      desc: 'Fasilitator & instruktur berlisensi BNSP',
    },
    {
      id: 'qs-4',
      icon: 'HeartHandshake',
      value: '10+ Thn',
      label: 'Pengalaman Teruji',
      desc: 'Ahli dalam event, web & ekosistem UMKM',
    },
  ];

  const items = settings?.quickStats?.items && settings.quickStats.items.length > 0
    ? settings.quickStats.items
    : defaultItems;

  return (
    <section id="quick-stats-section" className="py-6 sm:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
          {items.map((stat, idx) => {
            const IconComp = iconMap[stat.icon] || Award;
            return (
              <div
                key={stat.id || idx}
                className="bg-white p-3.5 sm:p-5 rounded-xl sm:rounded-2xl border border-slate-200/80 shadow-2xs hover:shadow-xs hover:border-slate-300 transition-all flex flex-col sm:flex-row items-start sm:items-center gap-2.5 sm:gap-4"
              >
                <div
                  className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center text-white shrink-0 shadow-2xs"
                  style={{ backgroundColor: primaryColor }}
                >
                  <IconComp className="w-5 h-5 sm:w-6 sm:h-6" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-extrabold text-slate-900 tracking-tight leading-none">
                    {stat.value}
                  </div>
                  <div className="text-xs sm:text-sm font-extrabold text-slate-800 mt-1 leading-tight break-words">
                    {stat.label}
                  </div>
                  <div className="text-[11px] sm:text-xs text-slate-500 mt-1 leading-snug break-words">
                    {stat.desc}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
